import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class GetPVSIngestionData extends BaseService {
  constructor() {
    super(constants.GET_SEARCH_INGESTION_RESPONSE, 'GetPVSIngestionDataStatus');
  }

  handleEvent(eventName, event) {
    const { tenantId, ...payload } = event.payload;
    const headers = { [constants.BERLIN_TENANT_ID_HEADER]: tenantId };
    return this.getClient('evergreen').post(`/chatUtility/getpvsingestionstatus`, payload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success' && data?.data?.data.length > 0) {
      Framework.getStoreRegistry().getStore('ingestionData').setResponse(response);
    } else {
      const notification = {
        open: true,
        message: 'Data Not Found',
        type: 'info'
      };
      const responseObj = {
        status: 'success',
        data: []
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('ingestionData').setResponse(responseObj);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
